import { default as BaseDrawer } from '@mui/joy/Drawer';
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import type { DrawerProps } from './types';

const Drawer = forwardRef<HTMLDivElement, DrawerProps>((props, ref) => {
  const { keepMounted = false, slotProps, showBackdrop = true, ...rest } = props;

  const tranparentBg = !showBackdrop ? 'bg-transparent' : '';

  const mergedSlotProps = useMemo(() => {
    return {
      ...slotProps,
      root: {
        ...slotProps?.root,
        className:
          slotProps?.root && 'className' in slotProps.root
            ? clsx('ua-drawer', slotProps.root.className)
            : 'ua-drawer',
      },
      backdrop: {
        ...slotProps?.backdrop,
        sx: {
          ...(!showBackdrop && { backdropFilter: 'none' }),
        },
        className:
          slotProps?.backdrop && 'className' in slotProps.backdrop
            ? clsx(tranparentBg, slotProps.backdrop.className)
            : tranparentBg,
      },
    };
  }, [slotProps, tranparentBg, showBackdrop]);

  if (!keepMounted && !rest.open) {
    return null;
  }

  // https://mui.com/joy-ui/customization/right-to-left/
  let dirProps = {};
  if (typeof document !== 'undefined') {
    dirProps = { dir: document.dir };
  }

  return <BaseDrawer {...dirProps} ref={ref} {...rest} slotProps={mergedSlotProps} />;
});

Drawer.displayName = 'Drawer';

export default Drawer;
